import { render } from "./RegistrationInformationsComponent.vue?vue&type=template&id=24c06a1a&scoped=true"
import script from "./RegistrationInformationsComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationInformationsComponent.vue?vue&type=script&lang=js"

import "./RegistrationInformationsComponent.vue?vue&type=style&index=0&id=24c06a1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c06a1a"]])

export default __exports__